import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  signal
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize, Observable, tap } from 'rxjs';
import { ToastService } from '~backoffice/app/~shared/services/toast.service';

@Component({
  selector: 'delete-confirm',
  standalone: false,
  templateUrl: './delete-confirm.component.html',
  styleUrl: './delete-confirm.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeleteConfirmComponent {
  showFullContent = input<boolean>(false);
  wordEntry = input<string>('Je confirme la suppression');
  action = input<string | undefined>();
  cancel = input<string | undefined>();
  removeObservable$ = input<Observable<unknown> | undefined>();
  title = input<string | undefined>();
  subtitle = input<string | undefined>();
  instruction = input<string | undefined>();
  iconClass = input<string | string[]>('fa-trash');
  type = input<'info' | 'danger'>('danger');

  public dialogRef = inject(MatDialogRef<DeleteConfirmComponent>);
  private _destroy$ = inject(DestroyRef);
  private _toastService = inject(ToastService);

  isLoading = signal(false);
  inputValue = '';
  defaultWordEntry = 'Je confirme la suppression';
  defaultTitle = 'Voulez vous supprimer le document ?';
  defaultSubtitle =
    'Cette action est irréversible. Voulez-vous vraiment supprimer cet élément ? Aucune récupération ne sera possible après validation.';

  defaultInstruction =
    'Veuillez saisir le texte ci-dessous pour confirmer la suppression';

  confirm(): void {
    const removeObservable = this.removeObservable$();
    if (removeObservable) {
      this.isLoading.set(true);
      removeObservable
        .pipe(
          takeUntilDestroyed(this._destroy$),
          finalize(() => {
            this.isLoading.set(false);
          }),
          tap({
            next: res => {
              this.dialogRef.close(res ?? true);
            },
            error: error => {
              this._toastService.open({
                content: error.error.detail,
                type: 'error'
              });

              this.isLoading.set(false);
            }
          })
        )
        .subscribe();
    }
  }

  get isButtonDisabled(): boolean {
    if (!this.showFullContent()) {
      return false;
    }
    const wordEntry = this.wordEntry() || this.defaultWordEntry;
    return this.inputValue !== wordEntry || this.isLoading();
  }
}
